import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AboutUsService {
  url = environment.url;

  constructor(private http: HttpClient) { }

  send_email(data){
    return this.http.post(this.url + '/send_email', data)
  }
  
}
